import React, { type ReactNode } from 'react';

type TableContainerProps = {
  children: ReactNode;
  className?: string;
};

export const TableContainer = ({ children, className }: TableContainerProps): React.ReactElement => {
  /** `overflow-hidden` keeps inner content clipped to rounded corners. Hover tooltips for header/toolbar use a Radix portal (rendered to `document.body`) so they aren't affected. */
  const containerClassName = className
    ? `bg-white rounded-lg shadow-sm border border-gray-200 min-w-0 overflow-hidden ${className}`
    : 'bg-white rounded-lg shadow-sm border border-gray-200 min-w-0 overflow-hidden';

  return <div className={containerClassName}>{children}</div>;
};
